"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrderAlertsData = void 0;
var i18n_1 = __importStar(require("../i18n"));
/**
 * Order all the alerts received
 * @param alerts Alerts to order
 * @param language seleced language
 * @returns Ordered list
 */
var buildOrderAlertsData = function (alerts, language) {
    var _a, _b, _c;
    // get only overConsumption with notifications and also adapt the object to be usable
    var overConsumptionAlerts = ((_a = alerts.overConsumptionAlerts) !== null && _a !== void 0 ? _a : [])
        .filter(function (overConsumptionAlert) {
        return overConsumptionAlert.notifications &&
            overConsumptionAlert.notifications.length !== 0;
    })
        .map(function (alert) { return ({
        id: alert.overConsumptionId,
        openingDate: alert.openingDate,
        closingDate: alert.closingDate,
        title: (0, i18n_1.getTransation)(function (t) { return t.exchanges.overconsumingAlertsSection.alertBoxTitle; }, {
            qty: alert.totalConsumptionVolume.toString(),
            duration: alert.totalDaysDuration.toString()
        })((0, i18n_1.default)(language)),
        type: (0, i18n_1.default)(language).exchanges.overconsumingAlertsSection.type,
        notifications: alert.notifications
    }); });
    //  Adapt the data structure in order to be usable in mobile and front comonents
    var residualLeakAlerts = ((_b = alerts.residualLeakAlerts) !== null && _b !== void 0 ? _b : []).map(function (alert) { return ({
        id: alert.residualLeakId,
        openingDate: alert.openingDate,
        closingDate: alert.closingDate,
        title: (0, i18n_1.default)(language).exchanges.residualLeakAlertsSection
            .residualLeakInformation,
        type: (0, i18n_1.default)(language).exchanges.residualLeakAlertsSection.type
    }); });
    // Adapt the data structure in order to be usable in mobile and front comonents
    var tranquilityAlerts = ((_c = alerts.tranquilityAlerts) !== null && _c !== void 0 ? _c : []).map(function (alert) { return ({
        id: alert.tranquilityAlertId,
        openingDate: alert.alertDate,
        closingDate: alert.alertDate,
        title: (0, i18n_1.getTransation)(function (t) {
            return t.exchanges.traquilityAlertSection.tranquilityInformation;
        }, {
            value: alert.lastDayConsumption
        })((0, i18n_1.default)(language)),
        type: (0, i18n_1.default)(language).exchanges.traquilityAlertSection.type
    }); });
    // Get overConsumptionAlerts with closingDate null
    var overConsumptionAlertNull = overConsumptionAlerts.filter(function (overConsumptionAlert) { return !overConsumptionAlert.closingDate; });
    // Get overConsumptionAlerts with closingDate not null
    var overConsumptionAlertNotNull = overConsumptionAlerts.filter(function (overConsumptionAlert) { return overConsumptionAlert.closingDate; });
    // Get residualLeakAlerts with that are not expired
    var residualLeakAlertsNotClosed = residualLeakAlerts.filter(function (residualLeakAlert) { return !residualLeakAlert.closingDate; });
    // Get residualLeakAlerts with expired and not null closingDate
    var residualLeakAlertsClosed = residualLeakAlerts.filter(function (residualLeakAlert) {
        return residualLeakAlert.closingDate &&
            new Date(residualLeakAlert.closingDate) < new Date();
    });
    // Create first array that contains alerts that we need to dispaly at the end, sorted by closing date or opening date in case of tranqility alerts
    var alertSecondLevel = __spreadArray(__spreadArray(__spreadArray([], tranquilityAlerts, true), overConsumptionAlertNotNull, true), residualLeakAlertsClosed, true).sort(function (a, b) {
        var dateA = new Date(a.closingDate || a.openingDate);
        var dateB = new Date(b.closingDate || b.openingDate);
        return dateB - dateA;
    });
    // Combine and return the ordered elements
    return __spreadArray(__spreadArray(__spreadArray([], overConsumptionAlertNull, true), residualLeakAlertsNotClosed, true), alertSecondLevel, true);
};
exports.buildOrderAlertsData = buildOrderAlertsData;
